
const toKebabCase = (str) => {
    return str
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .toLowerCase();
};

const toPascalCase = (str) => {
    return str
        .replace(/(\w)(\w*)/g, (_, firstChar, rest) =>
            firstChar.toUpperCase() + rest.toLowerCase()
        )
        .replace(/[\s_-]+/g, '');
};

export { toKebabCase, toPascalCase };